import { Component, OnInit } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ActivatedRoute } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { MessageModule } from 'primeng/message';
import { ProgressBarModule } from 'primeng/progressbar';
@Component({
  selector: 'app-besharp-oauth2-callback',
  imports: [ProgressBarModule, DividerModule, MessageModule],
  templateUrl: './oauth2-callback.component.html',
  styleUrl: './oauth2-callback.component.scss',
})
export class OAuth2CallbackComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  protected status: 'loading' | 'success' | 'error' = 'loading';
  protected errorMessage: string = 'Error during sign-in';

  ngOnInit(): void {
    setTimeout(() => window.close(), 1500);

    const sessionChannel = new BroadcastChannel(`oauth2-callback`);

    const authorizationId = this.route.snapshot.queryParamMap.get('state');

    if (!authorizationId) {
      this.status = 'error';
      this.errorMessage = 'Authorization ID not found in the state query param';
      console.debug(this.errorMessage);
      return;
    }

    console.debug('Authorization ID: ' + authorizationId);

    const error = this.route.snapshot.queryParamMap.get('error');
    if (error) {
      this.status = 'error';
      this.errorMessage = error;
      sessionChannel.postMessage({
        authorizationId: authorizationId,
        code: null,
        error: error,
      });
      return;
    }

    const code = this.route.snapshot.queryParamMap.get('code') ?? '';
    this.status = 'success';
    sessionChannel.postMessage({
      authorizationId: authorizationId,
      code: code,
      error: null,
    });
  }
}
